import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "@material-ui/core/Select";
import { StorageUser } from "../../main/StorageUser";

import {
  Button,
  Dialog,
  DialogActions,
  FormControl,
  DialogContent,
  DialogContentText,
  Box,
  TextareaAutosize,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { red, grey } from "@material-ui/core/colors";
import { getMotivosInsucesso } from "../../state/order/actions";
import ReCAPTCHA from "react-google-recaptcha";
import consts from "../../main/consts";

import Authorization from "./Authorization";
import { axiosGet } from "../../main/app-axios";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: red[900],
    color: "#fff",
    "&:hover": {
      backgroundColor: red[800],
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  textLabel: {
    fontSize: "1rem",
    padding: "0px",
  },
  container: {
    maxHeight: "100vh",
    minWidth: 420,
    minHeight: 130,
    padding: 0,
  },
  listContent: {
    borderBottom: `2px solid ${grey[200]}`,
  },
  listContentSelect: {
    borderBottom: `2px solid ${grey[200]}`,
    marginTop: theme.spacing(3),
  },
  listContentToken: {
    borderBottom: `2px solid ${grey[200]}`,
  },
  action: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  skeleton: {
    margin: "5px",
    backgroundColor: "#ccc",
  },
  motivo: {
    marginTop: theme.spacing(4),
    display: "flex",
  },
  recaptcha: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  textToken: {
    textUnderlineOffset: "25%",
    fontSize: "2.5rem",
    textAlign: "center",
    textDecoration: `underline solid ${grey[400]} 1px`,
    margin: "0rem 2rem 0rem",
  },
  boxToken: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  form: {
    marginTop: theme.spacing(3),
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
}));

export default function MotivoInsucessoModal(props) {
  const { openModal, handleClose, submit, tokenInsucesso, getTokenInsucesso, orderId } = props;
  const [motivoInsucessoId, setMotivoInsucessoId] = useState(null);
  const { motivosInsucesso } = useSelector((state) => state.orders);
  const [motivoDevolucao, setMotivoDevolucao] = useState(null);
  const [recaptcha, setRecaptcha] = useState(!!consts.DISABLE_RECAPTCHA);
  const [token, setToken] = useState("");

  const dispatch = useDispatch();
  const classes = useStyles();

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const disabled = !motivoInsucessoId || !recaptcha || !motivoDevolucao;

  useEffect(() => {
    if (openModal) dispatch(getMotivosInsucesso());
  }, [openModal, dispatch]);

  useEffect(() => {
    if (openModal) {
      if (!tokenInsucesso && getTokenInsucesso) {
        axiosGet(`/api/pedidos/token-insucesso/${orderId}`).then((response) => {
          if (response && response.status === 200) {
            setToken(response.data.tokenInsucesso);
          };
        });
      } else {
        setToken(tokenInsucesso);
      }
    }
  }, [openModal, tokenInsucesso, getTokenInsucesso, orderId]);

  const handleSubmit = ({ nomeAutorizador, emailAutorizador } = {}) => {
    const motivoSelect = motivosInsucesso.find(
      (m) => m.motivo === motivoInsucessoId
    );
    if (motivoSelect)
      submit(motivoSelect, motivoDevolucao, nomeAutorizador, emailAutorizador);
  };

  const handleChange = (event) => {
    setMotivoInsucessoId(event.target.value);
  };

  return (
    <Dialog open={openModal}>
      <DialogContent className={classes.container}>
        <DialogContent className={classes.listContentToken}>
          <DialogContentText
            color="initial"
            variant="body2"
            className={classes.textLabel}
          >
            Selecione o motivo de <b>Retorno</b>:
          </DialogContentText>
        </DialogContent>
        <DialogContent className={classes.listContent}>
          <FormControl variant="outlined" fullWidth className={classes.form}>
            <Select
              native
              value={motivoInsucessoId}
              onChange={handleChange}
              label="Age"
              inputProps={{
                name: "motivoInsucessoId",
                id: "motivoInsucessoId",
              }}
            >
              <option key={`0-motivo`} value={""}>
                Selecione uma opção
              </option>
              {motivosInsucesso.map((item, index) => (
                <option key={`${index}-motivo`} value={item.motivo}>
                  {item.nome}
                </option>
              ))}
            </Select>
          </FormControl>
          <Box className={classes.motivo}>
            <TextareaAutosize
              fullWidth
              variant="outlined"
              placeholder="Digite aqui a observação"
              name="motivoDevolucao"
              id="motivoDevolucao"
              margin="dense"
              rowsMin={4}
              value={motivoDevolucao}
              style={{ flex: 1, padding: 10 }}
              onChange={(e) => {
                setMotivoDevolucao(e.target.value);
              }}
            />
          </Box>

          {motivoInsucessoId && (
            <>
              <DialogContent className={classes.listContentSelect}>
                <DialogContentText
                  color="initial"
                  variant="body2"
                  className={classes.textLabel}
                >
                  Código de Devolução para Entregador:
                </DialogContentText>
              </DialogContent>
              <Box className={classes.boxToken}>
                {token &&
                  token.split("").map((t) => (
                    <DialogContentText
                      color="primary"
                      variant="body2"
                      className={classes.textToken}
                    >
                      {t}
                    </DialogContentText>
                  ))}
              </Box>
            </>
          )}
          <Box className={classes.recaptcha}>
            {!consts.DISABLE_RECAPTCHA && (
              <ReCAPTCHA
                sitekey={consts.RECAPTCHA_KEY}
                onChange={(e) => setRecaptcha(true)}
              />
            )}
          </Box>
        </DialogContent>

        {requireAutorizador && (
          <Authorization
            action={handleSubmit}
            disabled={disabled}
            cancel={handleClose}
            cancelText="CANCELAR"
            actionText="Confirmar"
          />
        )}

        {!requireAutorizador && (
          <>
            <DialogActions className={classes.action}>
              <Box flexGrow={1} display="flex" p={0}>
                <Box flexGrow={1}>
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                  >
                    CANCELAR
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={disabled}
                    autoFocus
                  >
                    Confirmar
                  </Button>
                </Box>
              </Box>
            </DialogActions>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
